import React, { FC } from 'react';
import styled from 'styled-components';

import Heading, { HeadingVariant, HeadingScope } from 'src/components/Heading';
import { mediaQuery } from 'src/themes/breakpoints';
import { colors } from 'src/themes/colors';

const StyledService = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Title = styled(Heading)`
  color: ${colors.grey100};
  margin: 20px 0;
  text-align: center;

  ${mediaQuery('md')} {
    margin: 40px 0 20px;
  } ;
`;

const Text = styled.p`
  color: ${colors.grey100};
  text-align: center;
`;

const Img = styled.img`
  width: 90px;

  ${mediaQuery('lg')} {
    width: 120px;
  } ;
`;

interface ServiceProps {
  icon: string;
  title: string;
  text: string;
}

const Service: FC<ServiceProps> = ({ icon, title, text }) => (
  <StyledService>
    <Img alt={title} src={icon} />
    <HeadingScope>
      <Title variant={HeadingVariant.CHARLIE}>{title}</Title>
    </HeadingScope>
    <Text>{text}</Text>
  </StyledService>
);

export default Service;
